import React from 'react';
import { FaMotorcycle, FaCar, FaTruck } from 'react-icons/fa';

const VehicleTypeSelection = ({ formData, updateFormData, nextStep, prevStep }) => {
  const vehicleTypes = [
    { id: '2-Wheeler', label: '2-Wheeler', icon: FaMotorcycle },
    { id: '4-Wheeler', label: '4-Wheeler', icon: FaCar },
    { id: 'Others', label: 'Others', icon: FaTruck }
  ];
  
  const toggleVehicleType = (typeId) => {
    let updatedTypes = [...formData.vehicleTypes];
    
    if (updatedTypes.includes(typeId)) {
      updatedTypes = updatedTypes.filter(id => id !== typeId);
    } else {
      updatedTypes.push(typeId);
    }
    
    updateFormData({ vehicleTypes: updatedTypes });
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (formData.vehicleTypes.length === 0) {
      alert('Please select at least one vehicle type.');
      return;
    }
    
    nextStep();
  };
  
  return (
    <div>
      <h2 className="text-2xl font-semibold mb-6">Select Vehicle Types</h2>
      <p className="mb-4 text-gray-600">
        Block {formData.block}, Flat {formData.flatNumber}
      </p>
      <p className="mb-6 text-gray-600">
        Please select all vehicle types that you own. You can select multiple options.
      </p>
      
      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
          {vehicleTypes.map((type) => {
            const Icon = type.icon;
            const isSelected = formData.vehicleTypes.includes(type.id);
            
            return (
              <button
                key={type.id}
                type="button"
                onClick={() => toggleVehicleType(type.id)}
                className={`
                  p-6 flex flex-col items-center justify-center rounded-lg
                  transition-all duration-200 border-2
                  ${
                    isSelected
                      ? 'bg-blue-600 text-white border-blue-700'
                      : 'bg-white text-gray-800 border-gray-300 hover:border-blue-500'
                  }
                `}
              >
                <Icon className="text-4xl mb-3" />
                <span className="font-medium">{type.label}</span>
                <div className={`mt-3 w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                  isSelected ? 'border-white bg-white text-blue-600' : 'border-gray-400'
                }`}>
                  {isSelected && (
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  )}
                </div>
              </button>
            );
          })}
        </div>
        
        <div className="flex justify-between">
          <button
            type="button"
            onClick={prevStep}
            className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-6 rounded focus:outline-none focus:shadow-outline"
          >
            Back
          </button>
          
          <button
            type="submit"
            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded focus:outline-none focus:shadow-outline"
          >
            Next
          </button>
        </div>
      </form>
    </div>
  );
};

export default VehicleTypeSelection;
